import { CATALOG_INVENTORY } from 'App/featuresFlags';
import useGetTags from '../useGetTags';

function useHasCatalogInventory(): boolean {
  const tags = useGetTags();
  return tags.includes(CATALOG_INVENTORY);
}

export default useHasCatalogInventory;
